import { supabase } from '@/integrations/supabase/client';
import { createLogger } from '@/lib/structuredLogger';

const logger = createLogger('FirstRunRouting');

export async function resolveFirstRunRedirect(userId: string): Promise<string | null> {
  const resolution = await Promise.resolve()
    .then(() =>
      Promise.all([
        supabase.from('profiles').select('consent_data_processing').eq('id', userId).maybeSingle(),
        supabase.from('anamnesebogen').select('completed_at').eq('user_id', userId).maybeSingle(),
      ]),
    )
    .then(([profileResult, anamnesisResult]) => ({ profileResult, anamnesisResult }))
    .catch((error: unknown) => {
      logger.warn('First-run state request failed', { error });
      return null;
    });

  if (!resolution) return '/health-consent';
  const { profileResult, anamnesisResult } = resolution;

  if (profileResult.error || anamnesisResult.error) {
    logger.warn('Failed to resolve first-run state', {
      profileError: profileResult.error,
      anamnesisError: anamnesisResult.error,
    });
    // Consent-dependent health onboarding must never be bypassed when server state is unknown.
    return '/health-consent';
  }

  if (!anamnesisResult.data?.completed_at) {
    try {
      localStorage.removeItem('first_run_done');
    } catch {
      // Best effort only. Server state remains the source of truth.
    }
    return profileResult.data?.consent_data_processing ? '/anamnesebogen' : '/health-consent';
  }

  try {
    localStorage.setItem('first_run_done', '1');
  } catch {
    // Best effort only. Server state remains the source of truth.
  }

  return null;
}
